import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePayableModel } from "../payableModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportPayable } = usePayableModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportPayable()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}